import { Auth } from "./../auth.js"

//予約操作
export class CompanyController {
    constructor(apiRootPath){
        apiRootPath ??= window.Setting.api
        this.url = apiRootPath + "company"
    }

    /** GET name/list */
    async getNameList(){
        let res = await Auth.ajax({
            url: `${this.url}/name/list`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
        }
        return res
    }

    /** GET list */
    async getList(){
        let res = await Auth.ajax({
            url: `${this.url}/list`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
        }
        return res
    }

    /** GET :companyId | me */
    async getData(companyId){
        let res = await Auth.ajax({
            url: `${this.url}/${companyId ?? "me"}`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
        }
        return res
    }

    /** PUT :companyId */
    async updateData(data){
        let res = await Auth.ajax({
            method: "PUT",
            url: `${this.url}/${data.companyId}`,
            body: data,
        })
        return res
    }

    /** POST / */
    async createData(companyData, accounts){
        let res = await Auth.ajax({
            method: "POST",
            url: `${this.url}`,
            body: {company: companyData, accounts: accounts},
        })
        return res
    }
    
    /** GET :companyId/accounts  */
    async getAccounts(companyId){
        let res = await Auth.ajax({
            url: `${this.url}/${companyId}/accounts`,
        })
        if(res.ok){
            res.data = JSON.parse(res.body)
        }
        return res
    }

    /** POST :companyId/account */
    async createAccount(companyId, name){
        let res = await Auth.ajax({
            method: "POST",
            url: `${this.url}/${companyId}/account?id=${companyId}`,
            body: name,
        })
        return res
    }
    
    /** DELETE :companyId */
    async deleteData(companyId){
        let res = await Auth.ajax({
            method: "DELETE",
            url: `${this.url}/${companyId}`,
        })
        return res
    }
    
    /** POST | DELETE :companyId/disabled */
    async disabled(companyId, isDisabled){
        let res = await Auth.ajax({
            method: isDisabled ? "POST" : "DELETE",
            url: `${this.url}/${companyId}/disabled`,
        })
        return res
    }

    /** GET csv */
    async getCsv(){
        let res = await Auth.ajax({
            url: `${this.url}/csv`,
            responseType: "blob",
        })
        return res
    }

    /** GET statistic */
    async getStatistic(from, to){
        let res = await Auth.ajax({
            url: `${this.url}/statistic`
                + `?from=${from.getTime()/1000}`
                + `&to=${to.getTime()/1000}`,
        })
        if(res.ok) res.data = JSON.parse(res.body)
        return res
    }
}